import React from "react";
import { FooterMobile, Policy } from "../../../shared";

const PolicyMobile = () => {
  return (
    <Policy
      Footer={FooterMobile}
      footerWidths={["grid-2"]}
      widths={["grid-1", "grid-10"]}
      headerTextType="h500"
    ></Policy>
  );
};

export default PolicyMobile;
